// extracted by mini-css-extract-plugin
export var Hit = "search-module--Hit--a3f09";
export var HitHeader = "search-module--HitHeader--0e1db";
export var overlay = "search-module--overlay--dbfd9";
export var searchForm = "search-module--searchForm--7181e";
export var searchFormInput = "search-module--searchFormInput--e14d6";
export var searchPanelLabel = "search-module--searchPanelLabel--7edfc";